export default {"src":"/_next/static/media/AffordableOrthopedicIcon.972ab79b.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};